import React, { useState } from "react";
/** @jsx jsx */
import { jsx } from "@emotion/core";
import { Button } from ".";
import globalColors from "../styles/globalColors";
import { Collapse } from "antd";

type Props = {
  expanded?: boolean;
  onSelect: (value: YesNo) => void;
  question: string;
  value?: YesNo | null | undefined;
};

const YesNoQuestion: React.FC<Props> = ({
  children,
  expanded,
  onSelect,
  question,
  value
}) => {
  const [focused, setFocused] = useState(false);

  function onFocus() {
    setFocused(true);
  }

  function onBlur() {
    setFocused(false);
  }

  return (
    <div css={[styles.container, focused && styles.containerFocused]}>
      <Collapse
        bordered={false}
        activeKey={[expanded ? "1" : ""]}
        css={styles.collapseContainer}
      >
        <Collapse.Panel
          showArrow={false}
          header={
            <div css={styles.questionContainer}>
              {question}
              <div css={styles.buttonsContainer}>
                <Button
                  size="small"
                  buttonType={value === "YES" ? "secondary" : "tertiary"}
                  buttonStyle={value !== "YES" && styles.unselectedButton}
                  onClick={e => onSelect("YES")}
                  onFocus={onFocus}
                  onBlur={onBlur}
                >
                  Yes
                </Button>
                <Button
                  size="small"
                  buttonType={value === "NO" ? "secondary" : "tertiary"}
                  buttonStyle={value !== "NO" && styles.unselectedButton}
                  onClick={() => onSelect("NO")}
                  onFocus={onFocus}
                  onBlur={onBlur}
                >
                  No
                </Button>
              </div>
            </div>
          }
          key="1"
        >
          <div>{children}</div>
        </Collapse.Panel>
      </Collapse>
    </div>
  );
};

const styles = {
  buttonsContainer: {
    display: "flex"
  },
  collapseContainer: {
    ".ant-collapse-item": {
      border: "none !important"
    },
    ".ant-collapse-header": {
      padding: "0 !important"
    }
  },
  container: {
    border: `1px solid ${globalColors.orange}`,
    borderRadius: 3,
    marginBottom: 15
  },
  containerFocused: {
    border: `1px solid ${globalColors.secondary}`
  },
  questionContainer: {
    padding: "10px 15px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },
  unselectedButton: {
    borderColor: globalColors.secondary,
    borderRadius: 4,
    color: globalColors.secondary,
    ":hover, :focus": {
      color: "#90d2d0",
      borderColor: "#90d2d0"
    }
  }
};

export default YesNoQuestion;
